import * as rxjs from "rxjs";
import AppState from "../models/AppState";
import { delayed } from "../../methods";
import StorylineState from "../models/StorylineState";
import RoomState from "../models/RoomState";
import BottomModalState from "../models/BottomModalState";
import $events from "./EventBloc";
import { TutorialStep } from "../models/TutorialState";

class RoomBloc {
    constructor( storylineState ) {
        this.storylineState = storylineState;
        this.currentState   = storylineState?.roomState ?? new RoomState();
        this.stateSubject   = new rxjs.BehaviorSubject(this.currentState);
        this.initialTimerId = null;

        this.registerEvents();
    }

    registerEvents() {
        $events.$on('room/switch', ( room ) => {
            this.currentState.bottomModalState.close();
            this.switchRoom(room);
            $events.$emit('swipescreen/resetOffsets');
            this.startInitialTimer();
            this.pushState();
            // this.storylineState.roomState.showDefaultRoomContent();
        });

        $events.$on('tutorial/skip', () => {
            this.currentState.bottomModalState.close();
            this.switchRoom(this.storylineState.startingRoom);
            $events.$emit('swipescreen/resetOffsets');
            this.startInitialTimer();
            this.pushState();
        });
    }

    switchRoom( room ) {
        let roomTo         = this.storylineState.getStorylineRoom(room.id);
        let staticTutorial = this.currentState.tutorialState.staticTutorial;
        this.currentState  = new RoomState(roomTo);

        if ( staticTutorial ) {
            this.currentState.tutorialState.staticTutorial = staticTutorial;
            this.currentState.tutorialState.swipeLearned = true;
        }
    }

    showDefaultRoomContent( props = { initClosed: false } ) {
        this.currentState.bottomModalState = new BottomModalState(
            {
                initClosed: props.initClosed,
                obj:        this.currentState.room,
                type:       'content'
            }
        );
        this.pushState();
    }

    showInfoSpotContent( spot ) {
        this.currentState.bottomModalState = new BottomModalState({
            obj:  spot,
            type: ( spot.type === 'room' ) ? 'room' : 'content'
        });
        this.pushState();
    }

    selectInfoSpot( spot ) {
        if ( this.currentState.room.isTutorialRoom ) {
            this.currentState.tutorialState.finish();
            this.currentState.bottomModalState.open();
            this.pushState();
            return;
        }

        this.showInfoSpotContent(spot);
        this.currentState.bottomModalState.open();
        this.pushState();
    }

    async onBackgroundTap() {
        if ( this.initialTimerId !== null ) {
            this.cancelInitialTimer();
            this.currentState.bottomModalState.close();
            this.pushState();
        }

        if ( this.currentState.bottomModalState.isOpen ) {
            this.currentState.bottomModalState.close();
            this.pushState();
            await delayed(350);
            this.showDefaultRoomContent({
                initClosed: true
            });
        }
    }

    openBottomModal() {
        console.log("open bottom modal");
        this.cancelInitialTimer();

        this.currentState.bottomModalState.open();
        this.pushState();
    }

    closeBottomModal() {
        this.currentState.bottomModalState.close();
        this.pushState();
    }

    updateBottomModalState( newState ) {
        this.currentState.bottomModalState = newState;
        this.pushState();
    }

    async startInitialTimer() {
        this.cancelInitialTimer();
        this.initialTimerId = setTimeout(() => {
            this.currentState.bottomModalState.close();
            this.initialTimerId = null;
            this.pushState();
        }, 3000);
    }

    cancelInitialTimer() {
        // this.initialTimerCancel = true;
        if ( this.initialTimerId == null ) return;

        clearTimeout(this.initialTimerId);
        this.initialTimerId = null;
    }

    onRoomOverviewTap() {
        this.cancelInitialTimer();
        this.currentState.bottomModalState = new BottomModalState({
            type: 'overview'
        });
        this.currentState.bottomModalState.open();
        this.pushState();
    }

    onHelpTap() {
        this.currentState.tutorialState.restart();
        this.currentState.tutorialState.forceShowTutorial = true;
        this.pushState();
    }

    startTutorial( isStatic = false ) {
        this.currentState.tutorialState.start(isStatic);
        this.currentState.bottomModalState.close();
        this.pushState();
    }

    markSwipeAsLearned() {
        this.currentState.tutorialState.swipeLearned = true;
        this.pushState();
    }

    getRoomClasses( roomState ) {
        if ( typeof roomState == "undefined" || roomState == null ) {
            return '';
        }

        let className = '';
        if ( roomState?.bottomModalState?.isOpen ?? false ) {
            className += '  room-screen--bottom-modal-open';
        }

        if ( roomState?.bottomModalState?.isInitial ?? true ) {
            className += '  room-screen--bottom-modal-initial';
        }

        if ( roomState.tutorialState.currentStep === TutorialStep.Start ) {
            className += '  tutorial--start';
        }

        if ( roomState.tutorialState.currentStep === TutorialStep.Step1 ) {
            className += '  tutorial--step1';
        }

        if ( roomState.tutorialState.currentStep === TutorialStep.Finished ) {
            className += '  tutorial--finished';
        }

        return className;
    }

    getSubject = () => this.stateSubject;

    pushState( newState = this.currentState ) {
        let state = newState ?? this.currentState;
        this.stateSubject.next(state);
    }
}

export default RoomBloc;
